export default "__VITE_ASSET__rQEWzgX8__"